<div class="kt-alert kt-alert-light items-start"
  [class.kt-alert-success]="type() === 'success'"
  [class.kt-alert-destructive]="type() === 'error'"
  [class.kt-alert-warning]="type() === 'warning'"
  [class.kt-alert-primary]="type() === 'info'"
  [attr.role]="type() === 'error' ? 'alert' : 'status'">
  <div class="grid min-w-0 flex-1 gap-2 break-words text-sm">
    <ng-content />
  </div>
  <button class="kt-btn kt-btn-sm kt-btn-icon kt-btn-ghost shrink-0" type="button"
    aria-label="Dismiss message" title="Dismiss message" (click)="dismissed.emit()">
    <i class="ki-filled ki-cross" aria-hidden="true"></i>
  </button>
</div>
